const initialState = {
    students: [],
    initialPending: [],  // This should be payments, but keeping your naming
    paymentErrors: [],   // Ensure this exists in the initial state
  };
  
  // Action Types
  const SET_STUDENTS = "SET_STUDENTS";
  const SET_PAYMENTS = "SET_PAYMENTS";
  const SET_PAYMENT_ERRORS = "SET_PAYMENT_ERRORS";
  
  // Action Creators
  export const setStudents = (students) => ({
    type: SET_STUDENTS,
    payload: students,
  });
  
  export const setPayments = (payments) => ({
    type: SET_PAYMENTS,
    payload: payments,
  });
  
  export const setPaymentErrors = (errors) => ({
    type: SET_PAYMENT_ERRORS,
    payload: errors,
  });
  
  // Reducer
  const payCheckReducers = (state = initialState, action) => {
    switch (action.type) {
      case SET_STUDENTS:
        return { ...state, students: action.payload };
        
      case SET_PAYMENTS:
        return { ...state, initialPending: action.payload };
  
      case SET_PAYMENT_ERRORS:
        return { ...state, paymentErrors: action.payload || [] }; // Prevent undefined
  
      default:
        return state;
    }
  };
  
  // Thunk to Check for Missing Payments
  export const checkPayments = () => (dispatch, getState) => {
    const { students, initialPending } = getState().initialPending;
    const paidStudentUids = new Set(initialPending.map((p) => p.student_uid));
    const unpaidStudents = students.filter((s) => !paidStudentUids.has(s.student_uid));
  
    if (unpaidStudents.length > 0) {
      const errors = unpaidStudents.map((s) => `Payment for student ${s.student_uid} (${s.full_name}) is not completed.`);
      dispatch(setPaymentErrors(errors));
    } else {
      dispatch(setPaymentErrors([]));
    }
  };
  
  export default payCheckReducers;
  